// removed by extract-text-webpack-plugin
module.exports = {"loading":"Loading__loading","callToAction":"Loading__callToAction","loader":"Loading__loader","dots":"Loading__dots","growDotGolden":"Loading__growDotGolden","growDotQello":"Loading__growDotQello","growDotBlue":"Loading__growDotBlue","default":"Loading__default","outline":"Loading__outline"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/Loading.scss
// module id = 1858
// module chunks = 0